const { ButtonPrimary } = require('@americanexpress/dls-react');
import React from "react"
import { Fragment } from "react"
import styles from '../assets/ConfirmScreen.module.css';

interface ConfirmPageProps {
    icon: any,
    title: string,
    description: string,
    buttonText: string,
    handleClick: any;
    showContinueButton: boolean;
}

const ConfirmScreen: React.FC<ConfirmPageProps> = (props) => {
    return (
        <Fragment>
            <div className={`container margin-2-b margin-1-t pad-4 dls-white-bg`}>
                <div className={`${styles.customCenter}`}>
                    <div>
                        {props.icon}
                    </div>
                </div>
                <div className="text-align-center">
                    <p className="heading-5 pad-2-t">{props.title}</p>
                    <p className="body-1 pad-2-tb">{props.description}</p>
                    {props.showContinueButton && 
                        <ButtonPrimary id="confirm-button" size="md" className="btn btn-block margin-auto-lr" onClick={props.handleClick}>
                            {props.buttonText}
                        </ButtonPrimary>
                        
                    } 
                </div>
            </div>
        </Fragment>
    )

}

export default ConfirmScreen;
